import { ExternalLink } from "@/components/buttons/ExternalLink";
import { MenuItem } from "@/components/layouts/MenuItem";
import { useSidebar } from "@/components/layouts/SidebarContext";
import { getCommsConfig, getConfig, getDocsConfig, getKbConfig } from "@/features/branding";
import supabase from "@/features/supabase";
import { useGetOrgQuery } from "@/store/services/supabase";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { Dropdown } from "antd";
import { ItemType } from "antd/lib/menu/interface";
import Link from "next/link";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
const MARSH_ORG_ID = "ec94cfd6-2a66-40d2-ad48-d04702c5a0f9";
const MARSH_TICKET_REQUEST_HS_ID = "1WLrNIdtGRtK1-KtLhA6-dw4lsth";
export const HelpDropdownButton = () => {
  const {
    t
  } = useTranslation();
  const {
    data: org
  } = useGetOrgQuery();
  const {
    isSidebarCollapsed
  } = useSidebar();
  const [showAdminTutorialOption, setShowAdminTutorialOption] = useState(false);
  const {
    support,
    emailSupport,
    reseller
  } = getCommsConfig();
  const {
    faqs,
    changeLog
  } = getKbConfig();
  const {
    tutorialsAndTips
  } = getDocsConfig();
  const topLevelItems: ItemType[] = [];
  useEffect(() => {
    if (getDocsConfig().accountManagementTutorial.enabled) {
      supabase.rpc("is_owner").then(({
        data
      }) => {
        setShowAdminTutorialOption(data || false);
      });
    }
  }, []);
  if (support.enabled && support.url) {
    topLevelItems.push({
      key: "comms:support",
      label: <Link href={support.url}>Contact Support</Link>
    });
  }
  if (emailSupport.enabled) {
    topLevelItems.push({
      key: "comms:emailSupport",
      label: <ExternalLink href={`mailto:${emailSupport.email}`}>Email Support</ExternalLink>
    });
  }
  if (reseller?.ticketRequestForm.enabled) {
    if (org?.id === MARSH_ORG_ID) {
      topLevelItems.push({
        key: "comms:reseller:ticketRequestForm",
        label: <ExternalLink href={`https://share.hsforms.com/${MARSH_TICKET_REQUEST_HS_ID}`}>Ticket Request</ExternalLink>
      });
    }
  }
  if (tutorialsAndTips.enabled && tutorialsAndTips?.url) {
    topLevelItems.push({
      key: "tutorials:tools",
      label: <Link href={tutorialsAndTips.url}>{t("pages:tutorialsAndTips.title")}</Link>
    });
  }
  if (showAdminTutorialOption) {
    topLevelItems.push({
      key: "tutorials:administrative",
      label: <ExternalLink href="https://climaterisk.hk/admin-tutorial">Account Mgmt Tutorial</ExternalLink>
    });
  }
  if (faqs.enabled) {
    topLevelItems.push({
      key: "resource:faqs",
      label: faqs.publicDocsUrl ? <ExternalLink href={faqs.publicDocsUrl}>{t("pages:knowledgeBase.faqs.title")}</ExternalLink> : <Link href="/faqs/_">{t("pages:knowledgeBase.faqs.title")}</Link>
    });
  }
  if (topLevelItems.length) {
    topLevelItems.push({
      type: "divider"
    });
  }
  if (changeLog.enabled) {
    topLevelItems.push({
      key: "resource:changeLog",
      label: <Link href="/changelog">{t("pages:knowledgeBase.changeLog.title")}</Link>
    });
  }
  const buildLegalItems = (): ItemType[] => {
    const {
      privacyPolicy,
      termsOfService
    } = getConfig().featureSet.docs.legal;
    return [{
      key: "termsOfService",
      label: <ExternalLink href={termsOfService}>{t("terms:documents.termsOfService")}</ExternalLink>
    }, {
      key: "privacyPolicy",
      label: <ExternalLink href={privacyPolicy}>{t("terms:documents.privacyPolicy")}</ExternalLink>
    }];
  };

  // If we have no help items to offer, just hide this.
  const items = [...topLevelItems, ...buildLegalItems()];
  if (items.length === 0) {
    return <></>;
  }
  return <Dropdown menu={{
    items
  }} trigger={["click"]} classNames={{
    root: "!min-w-60"
  }} data-sentry-element="Dropdown" data-sentry-component="HelpDropdownButton" data-sentry-source-file="HelpDropdownButton.tsx">
      <div className={`min0w mx-1 my-1 flex h-8 items-center rounded-md px-[10px] hover:bg-gray-100`}>
        <MenuItem icon={<QuestionCircleOutlined />} isSidebarCollapsed={isSidebarCollapsed} toolLabel="Help" isExternal={false} data-sentry-element="MenuItem" data-sentry-source-file="HelpDropdownButton.tsx" />
      </div>
    </Dropdown>;
};